export default "__VITE_ASSET__u7JV$2IZ__"